import { createFileRoute } from '@tanstack/react-router';

import { Users } from 'features/account/Users';

export const Route = createFileRoute('/_authenticated/account/_shell/users')({
  component: AccountUsersRoute
});

function AccountUsersRoute() {
  return <Users />;
}
